import { createAction, props } from '@ngrx/store';
import { BadResponseWithError } from '@shared/models/common.interface';

export const FETCH_CHALLENGES_REQUEST =
    '[Challenges] Fetch CHALLENGES requests';
export const FETCH_CHALLENGES_SUCCESS = '[Challenges] Fetch CHALLENGES success';
export const FETCH_CHALLENGES_FAILURE = '[Challenges] Fetch CHALLENGES failure';
export const fetchChallengesRequests = createAction(
    FETCH_CHALLENGES_REQUEST,
    props<{ categoryId: string }>()
);

export const fetchChallengesSuccess = createAction(
    FETCH_CHALLENGES_SUCCESS,
    props<{ payload: any }>()
);

export const fetchChallengesFailure = createAction(
    FETCH_CHALLENGES_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
export const CREATE_SINGLE_REWARDS_REQUEST =
    '[Challenges] Create single rewards requests';
export const CREATE_SINGLE_REWARDS_SUCCESS =
    '[Challenges] Create single rewards success';
export const CREATE_SINGLE_REWARDS_FAILURE =
    '[Challenges] Create single rewards failure';
export const createSingleRewardsRequests = createAction(
    CREATE_SINGLE_REWARDS_REQUEST,
    props<{ payload: any }>()
);

export const createSingleRewardsSuccess = createAction(
    CREATE_SINGLE_REWARDS_SUCCESS,
    props<{ payload: any }>()
);

export const createSingleRewardsFailure = createAction(
    CREATE_SINGLE_REWARDS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const CREATE_GROUP_REWARDS_REQUEST =
    '[Challenges] Create group rewards requests';
export const CREATE_GROUP_REWARDS_SUCCESS =
    '[Challenges] Create current group rewards success';
export const CREATE_GROUP_REWARDS_FAILURE =
    '[Challenges] Create current group rewards failure';
export const createGroupRewardsRequests = createAction(
    CREATE_GROUP_REWARDS_REQUEST,
    props<{ payload: any }>()
);

export const createGroupRewardsSuccess = createAction(
    CREATE_GROUP_REWARDS_SUCCESS,
    props<{ payload: any }>()
);

export const createGroupRewardsFailure = createAction(
    CREATE_GROUP_REWARDS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const FETCH_CATEGORIES_FOR_REWARDS_REQUEST =
    '[Challenges] Fetch categories for  rewards requests';
export const FETCH_CATEGORIES_FOR_REWARDS_SUCCESS =
    '[Challenges] Fetch categories for  rewards success';
export const FETCH_CATEGORIES_FOR_REWARDS_FAILURE =
    '[Challenges] Fetch categories for  rewards failure';
export const fetchCategoriesForRewardsRequests = createAction(
    FETCH_CATEGORIES_FOR_REWARDS_REQUEST
);

export const fetchCategoriesForRewardsSuccess = createAction(
    FETCH_CATEGORIES_FOR_REWARDS_SUCCESS,
    props<{ payload: any }>()
);

export const fetchCategoriesForRewardsFailure = createAction(
    FETCH_CATEGORIES_FOR_REWARDS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
export const FETCH_EVENT_TYPES_FOR_REWARDS_REQUEST =
    '[Challenges] Fetch EVENT_TYPES for  rewards requests';
export const FETCH_EVENT_TYPES_FOR_REWARDS_SUCCESS =
    '[Challenges] Fetch EVENT_TYPES for  rewards success';
export const FETCH_EVENT_TYPES_FOR_REWARDS_FAILURE =
    '[Challenges] Fetch EVENT_TYPES for  rewards failure';
export const fetchEventTypesForRewardsRequests = createAction(
    FETCH_EVENT_TYPES_FOR_REWARDS_REQUEST
);

export const fetchEventTypesForRewardsSuccess = createAction(
    FETCH_EVENT_TYPES_FOR_REWARDS_SUCCESS,
    props<{ payload: any }>()
);

export const fetchEventTypesForRewardsFailure = createAction(
    FETCH_EVENT_TYPES_FOR_REWARDS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const UPDATE_SINGLE_REWARDS_REQUEST =
    '[Challenges] Update current single rewards requests';
export const UPDATE_SINGLE_REWARDS_SUCCESS =
    '[Challenges] Update current single rewards success';
export const UPDATE_SINGLE_REWARDS_FAILURE =
    '[Challenges] Update current single rewards failure';
export const updateSingleRewardsRequests = createAction(
    UPDATE_SINGLE_REWARDS_REQUEST,
    props<{
        payload: {
            challengeId: string;
            body: any;
        };
    }>()
);

export const updateSingleRewardsSuccess = createAction(
    UPDATE_SINGLE_REWARDS_SUCCESS,
    props<{ payload: any }>()
);

export const updateSingleRewardsFailure = createAction(
    UPDATE_SINGLE_REWARDS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const UPDATE_GROUP_REWARDS_REQUEST =
    '[Challenges] Update group rewards requests';
export const UPDATE_GROUP_REWARDS_SUCCESS =
    '[Challenges] Update group rewards success';
export const UPDATE_GROUP_REWARDS_FAILURE =
    '[Challenges] Update group rewards failure';
export const updateGroupRewardsRequests = createAction(
    UPDATE_GROUP_REWARDS_REQUEST,
    props<{
        payload: {
            groupId: string;
            body: any;
        };
    }>()
);

export const updateGroupRewardsSuccess = createAction(
    UPDATE_GROUP_REWARDS_SUCCESS,
    props<{ payload: any }>()
);

export const updateGroupRewardsFailure = createAction(
    UPDATE_GROUP_REWARDS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const CREATE_CHALLENGE_FOR_GROUP_REWARDS_REQUEST =
    '[Challenges] Create challenge for group rewards requests';
export const CREATE_CHALLENGE_FOR_GROUP_REWARDS_SUCCESS =
    '[Challenges] Create challenge for group rewards success';
export const CREATE_CHALLENGE_FOR_GROUP_REWARDS_FAILURE =
    '[Challenges] Create challenge for group rewards failure';
export const createChallengeForGroupRewardsRequests = createAction(
    CREATE_CHALLENGE_FOR_GROUP_REWARDS_REQUEST,
    props<{ payload: { groupId: string; body: any } }>()
);

export const createChallengeForGroupRewardsSuccess = createAction(
    CREATE_CHALLENGE_FOR_GROUP_REWARDS_SUCCESS,
    props<{ payload: { groupId: string; challenge: any } }>()
);

export const createChallengeForGroupRewardsFailure = createAction(
    CREATE_CHALLENGE_FOR_GROUP_REWARDS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const UPDATE_CHALLENGE_FOR_GROUP_REWARDS_REQUEST =
    '[Challenges] Update challenge for group rewards requests';
export const UPDATE_CHALLENGE_FOR_GROUP_REWARDS_SUCCESS =
    '[Challenges] Update challenge for group rewards success';
export const UPDATE_CHALLENGE_FOR_GROUP_REWARDS_FAILURE =
    '[Challenges] Update challenge for group rewards failure';
export const updateChallengeForGroupRewardsRequests = createAction(
    UPDATE_CHALLENGE_FOR_GROUP_REWARDS_REQUEST,
    props<{ payload: { groupId: string; challengeId: string; body: any } }>()
);

export const updateChallengeForGroupRewardsSuccess = createAction(
    UPDATE_CHALLENGE_FOR_GROUP_REWARDS_SUCCESS,
    props<{ payload: { groupId: string; challengeId: string; body: any } }>()
);

export const updateChallengeForGroupRewardsFailure = createAction(
    UPDATE_CHALLENGE_FOR_GROUP_REWARDS_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const DELETE_CHALLENGE_REQUEST =
    '[Challenges] Delete challenge for group rewards requests';
export const DELETE_CHALLENGE_SUCCESS =
    '[Challenges] Delete challenge  success';
export const DELETE_CHALLENGE_FAILURE = '[Challenges] Delete challenge failure';
export const deleteChallengeRequests = createAction(
    DELETE_CHALLENGE_REQUEST,
    props<{
        payload: {
            challengeId: string;
        };
    }>()
);

export const deleteChallengeSuccess = createAction(
    DELETE_CHALLENGE_SUCCESS,
    props<{ payload: any }>()
);

export const deleteChallengeFailure = createAction(
    DELETE_CHALLENGE_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

export const DELETE_GROUP_CHALLENGE_REQUEST =
    '[Challenges] Delete Group challenge for group rewards requests';
export const DELETE_GROUP_CHALLENGE_SUCCESS =
    '[Challenges] Delete Group challenge  success';
export const DELETE_GROUP_CHALLENGE_FAILURE =
    '[Challenges] Delete Group challenge failure';
export const deleteGroupChallengeRequests = createAction(
    DELETE_GROUP_CHALLENGE_REQUEST,
    props<{
        payload: {
            groupId: string;
        };
    }>()
);

export const deleteGroupChallengeSuccess = createAction(
    DELETE_GROUP_CHALLENGE_SUCCESS,
    props<{ payload: any }>()
);

export const deleteGroupChallengeFailure = createAction(
    DELETE_GROUP_CHALLENGE_FAILURE,
    props<{ payload: BadResponseWithError }>()
);

// Change Display Order
export const CHANGE_DISPLAY_ORDER_REQUEST =
    '[Challenges] Change Display order request';
export const CHANGE_DISPLAY_ORDER_SUCCESS =
    '[Challenges] Change Display order success';
export const CHANGE_DISPLAY_ORDER_FAILURE =
    '[Challenges] Change Display order failure';

export const changeDisplayOrderRequests = createAction(
    CHANGE_DISPLAY_ORDER_REQUEST,
    props<{
        payload: {
            displayNumbers: { entityId: string; displayOrderNumber: number }[];
        };
    }>()
);
export const changeDisplayOrderSuccess = createAction(
    CHANGE_DISPLAY_ORDER_SUCCESS,
    props<{
        payload: {
            displayNumbers: { entityId: string; displayOrderNumber: number }[];
        };
    }>()
);
export const changeDisplayOrderFailure = createAction(
    CHANGE_DISPLAY_ORDER_FAILURE,
    props<{ payload: BadResponseWithError }>()
);
